"use client";

import React from "react";
import { ArrowRight, Briefcase, Lightbulb, User, Users } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card } from "@/components/ui/card";
const services = [{
  title: "Individual Therapy",
  description: "One-on-one sessions focused on your personal journey, providing a safe space for deep exploration and restorative healing.",
  icon: User,
  href: "/OurHealingPathsPage"
}, {
  title: "Group Counseling",
  description: "Collaborative healing environments where shared experiences foster connection, understanding, and collective growth.",
  icon: Users,
  href: "/OurHealingPathsPage"
}, {
  title: "Supervised Clinical Care",
  description: "High-quality, affordable support provided by pre-licensed clinicians under the expert guidance of our Clinical Director.",
  icon: Briefcase,
  href: "/OurHealingPathsPage"
}, {
  title: "Growth Workshops",
  description: "Focused, interactive sessions designed to provide practical tools and insights for navigating life's transitions with resilience.",
  icon: Lightbulb,
  href: "/OurHealingPathsPage"
}];
export default function EliteCoachingSolutions() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}